// Stopping acting for a dependent.
//
// One definition, used by the standing banner and by the screen a guardian
// lands on when their access has ended. Two copies would eventually disagree
// about what "leave" clears, and the thing being cleared is whose record the
// app believes is on screen.
//
// Nothing is fetched on the way out: the account holder's own data was never
// replaced — `state.patient` is always the holder, and the dependent lives
// beside it in `activeDependent` — so leaving is only forgetting.

/**
 * @param {Function} navigate  react-router's navigate
 * @param {object}   state     current app state
 */
export function leaveDependent(navigate, state) {
  navigate("/", {
    state: {...state, viewingDependent: false, activeDependent: null},
  });
}
